(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pps-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pps-newsletter-popup')) {
  customElements.define('pps-newsletter-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.ready || document.querySelector('pps-newsletter-popup') !== this) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.storageKey = 'pps-newsletter:' + location.hostname + ':v1';
      this.pendingKey = this.storageKey + ':pending';
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('[data-newsletter-close]').forEach(button => button.addEventListener('click', () => this.dismiss(), options));
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dismiss(); }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...this.dialog.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')].filter(control => {
          const style = getComputedStyle(control);
          return !control.disabled && control.tabIndex >= 0 && control.getClientRects().length && style.visibility !== 'hidden' && style.display !== 'none';
        });
        const first = controls[0], last = controls[controls.length - 1], focused = document.activeElement;
        if (!first) { event.preventDefault(); this.querySelector('.pps-nl__title').focus(); return; }
        if (event.shiftKey && (focused === first || !controls.includes(focused))) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (focused === last || !controls.includes(focused))) { event.preventDefault(); first.focus(); }
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dismiss();
      }, options);
      this.querySelector('form').addEventListener('submit', () => {
        this.write('session', this.pendingKey, String(Date.now()));
      }, options);
      const result = this.querySelector('[data-newsletter-result]');
      const pending = Number(this.read('session', this.pendingKey));
      this.resultPending = Boolean(result && (!this.storageAvailable('session') || (pending > Date.now() - 600000 && pending <= Date.now())));
      if (this.resultPending) {
        this.write('session', this.pendingKey, '');
        if (result.dataset.newsletterResult === 'success') this.write('local', this.storageKey + ':subscribed', '1');
      }
      if (result && !this.resultPending) return;
      if (this.dataset.designMode === 'true') return;
      this.timer = setTimeout(() => this.maybeOpen(), this.resultPending ? 100 : Number(this.dataset.delay) || 12000);
      this.onPageHide = () => { if (this.dialog.open) this.dialog.close(); };
      window.addEventListener('pagehide', this.onPageHide, options);
    }
    storageAvailable(storage) {
      try {
        const store = window[storage + 'Storage'], key = this.storageKey + ':probe';
        store.setItem(key, '1');
        const available = store.getItem(key) === '1';
        store.removeItem(key);
        return available;
      } catch (_) { return false; }
    }
    read(storage, key) { try { return window[storage + 'Storage'].getItem(key) || ''; } catch (_) { return ''; } }
    write(storage, key, value) { try { window[storage + 'Storage'].setItem(key, value); } catch (_) {} }
    suppressed() {
      return this.dataset.subscriber === 'true' || this.read('local', this.storageKey + ':subscribed') === '1' ||
        Number(this.read('local', this.storageKey + ':dismissed')) > Date.now() ||
        this.read('session', this.storageKey + ':shown') === '1';
    }
    busy() {
      if (document.visibilityState !== 'visible' || /\/(cart|checkouts?|challenge|account)(\/|$)/.test(location.pathname)) return true;
      if (document.querySelector('cart-drawer.active, cart-drawer[open], #CartDrawer[aria-hidden="false"]')) return true;
      const dialogs = [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]:not([hidden])')];
      if (dialogs.some(dialog => {
        const style = getComputedStyle(dialog);
        return dialog !== this.dialog && dialog.getClientRects().length && style.visibility !== 'hidden' && style.display !== 'none' && style.opacity !== '0';
      })) return true;
      const focused = document.activeElement;
      return focused && focused.matches('input, textarea, select, [contenteditable="true"]');
    }
    maybeOpen() {
      if (!this.isConnected || (!this.resultPending && this.suppressed())) return;
      if (this.busy()) { this.timer = setTimeout(() => this.maybeOpen(), 3000); return; }
      this.previousFocus = document.activeElement;
      this.dialog.showModal();
      this.querySelector('.pps-nl__title').focus({ preventScroll: true });
      this.write('session', this.storageKey + ':shown', '1');
    }
    dismiss() {
      const days = Math.max(1, Math.min(60, Number(this.dataset.dismissDays) || 14));
      this.write('local', this.storageKey + ':dismissed', String(Date.now() + days * 86400000));
      this.write('session', this.storageKey + ':shown', '1');
      this.resultPending = false;
      this.dialog.close();
      if (this.previousFocus && this.previousFocus.isConnected && typeof this.previousFocus.focus === 'function') this.previousFocus.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.controller) this.controller.abort();
      if (this.dialog && this.dialog.open) this.dialog.close();
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pps-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pps-product')) {
  customElements.define('pps-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-show-slide]');
        if (!thumb || !this.contains(thumb)) return;
        this.querySelectorAll('[data-slide]').forEach((slide) => { slide.hidden = slide.dataset.slide !== thumb.dataset.showSlide; });
        this.querySelectorAll('[data-show-slide]').forEach((item) => { item.setAttribute('aria-pressed', String(item === thumb)); });
      });
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-option-position]')) this.changeVariant(event.target);
        if (event.target.matches('[data-preview-variant]')) {
          const option = event.target.selectedOptions[0];
          this.querySelector('.pps__price').textContent = option.dataset.price || '';
        }
      });
      if (this.dataset.preview === 'true') this.querySelector('form')?.addEventListener('submit', (event) => {
        event.preventDefault();
        this.querySelector('.pps__status').textContent = 'Preview only. No item was added to a cart.';
      });
    }
    variantRequestUrl(options) {
      const currentUrl = new URL(window.location.href);
      const productUrl = new URL(this.dataset.productUrl, window.location.origin);
      const isDraftPreview = currentUrl.pathname.endsWith('/products_preview') && currentUrl.searchParams.has('preview_key');
      const url = isDraftPreview || currentUrl.pathname === productUrl.pathname ? currentUrl : productUrl;
      for (const parameter of ['preview_theme_id', 'view', 'locale', 'lang']) {
        if (currentUrl.searchParams.has(parameter)) url.searchParams.set(parameter, currentUrl.searchParams.get(parameter));
      }
      url.searchParams.delete('variant');
      url.searchParams.delete('sections');
      url.searchParams.set('section_id', this.dataset.sectionId);
      url.searchParams.set('option_values', options.join(','));
      return url;
    }
    async changeVariant(control) {
      const options = Array.from(this.querySelectorAll('[data-option-position]')).map((select) => select.value);
      const url = this.variantRequestUrl(options);
      const position = control.dataset.optionPosition;
      this.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url.toString(), { headers: { 'Accept': 'text/html' } });
        if (!response.ok) throw new Error('Variant request failed');
        const markup = new DOMParser().parseFromString(await response.text(), 'text/html');
        const updated = markup.getElementById(this.id);
        if (!updated) throw new Error('Product section missing');
        this.replaceWith(updated);
        updated.querySelector(`[data-option-position="${position}"]`)?.focus({ preventScroll: true });
        const variant = updated.querySelector('[name="id"]')?.value;
        if (variant) {
          const browserUrl = new URL(window.location.href);
          browserUrl.searchParams.set('variant', variant);
          window.history.replaceState({}, '', browserUrl);
        }
      } catch (error) {
        this.removeAttribute('aria-busy');
        this.querySelector('.pps__status').textContent = this.dataset.errorMessage;
        this.querySelector('.pps__add').disabled = true;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
